import styled from '@emotion/styled'

export const ModalTitle = styled.h2(
  ({ theme }) => `
  font-weight: 900;
  text-align: center;
  font-size: 16px;
  line-height: 22px;
  color: ${theme.ds.ColorBaseBlack};
  @media (max-width: 768px) {
    font-size: 14px;
    font-weight: 500;
  }
`
)

export const ModalContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  @media (max-width: 768px) {
    font-size: 14px;
  }

  > div {
    width: 100%;
  }
`

export const ReasonsToClose = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  & > div:first-of-type {
    flex-grow: 0;
  }

  @media (max-width: 768px) {
    min-height: fit-content;
  }
`

export const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: flex-end;
  width: 100%;
  display: grid;
  column-gap: 16px;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    & button {
      margin-bottom: 16px;
    }
  }
`

export const ErrorParagraph = styled.div`
  font-size: 13px;
  text-align: center;
  color: #ff0000;
  text-transform: none;
`

export const ServerErrors = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
`

export const CallToActionParagraph = styled.div`
  margin: 15px 0 20px 0;
`

export const ObservationParagraph = styled.div`
  margin: 15px 0 20px 0;
  font-size: 13px;
  text-align: left;
  text-transform: none;
`

export const OtherReasonText = styled.div`
  margin: 15px 0;

  @media (max-width: 768px) {
    margin: 0 0 5px 0;
  }

  & > div {
    line-height: 0;

    & > textarea {
      margin-bottom: 0;
    }
  }
`
